<template>
  <BModal
    id="MfaApproachingModal"
    ref="theModal"
    class="modal"
  >
    <template #header>
      <h5>Multi-Factor Authentication</h5>
      <button
        class="btn btn--close"
        @click="cancel()"
      >
        <font-awesome-icon
          :icon="['fal', 'times']"
          class="icon alt"
        />
      </button>
    </template>
    <p>
      In order to protect the security of your data KGB Aviation Solutions, LLC
      implemented Multi-Factor authentication that is required by all users of
      our application.
    </p>
    <p class="alert-text">
      You have <b>{{ $store.getters.mfaWarning.daysRemaining }}</b> days with
      logins remaining before you must configure this.
    </p>

    <template #footer>
      <button
        class="btn"
        type="button"
        @click="cancel()"
      >
        Setup Later
      </button>
      <button
        class="btn btn--primary"
        type="button"
        @click="goToMfa()"
      >
        <span>Configure Now</span>
      </button>
    </template>
  </BModal>
</template>

<script>

import {BModal} from "bootstrap-vue-next";

export default {
  name: 'MfaApproachingModal',
  components: {BModal},
  methods: {
    cancel() {
      this.$refs.theModal.hide();
    },
    goToMfa() {
      this.$refs.theModal.hide();

      this.$router.push({name: 'account'});
    },
    show() {
      this.$refs.theModal.show();
    },
  },
};
</script>

<style scoped lang="scss">

</style>
